export default __webpack_public_path__ + "static/media/RequisitionIcon.cd04b6d0.svg";